(() => {
  if (customElements.get('education-course')) return;
  class EducationCourse extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.closest('form');
      this.content = this.querySelector('[data-course-content]');
      this.error = this.querySelector('[data-course-error]');
      this.form?.addEventListener('variant:change', event => this.render(event.detail.variant?.id), options);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-course-campus]')) this.selectCampus();
      }, options);
      this.form?.addEventListener('submit', event => {
        const campus = this.content.querySelector('[data-course-campus]');
        const quantity = Number(this.form.querySelector('[name="quantity"]')?.value || 1);
        const seats = Number(campus?.selectedOptions[0]?.dataset.seats || 0);
        if (!this.available || !campus?.value || quantity > seats || quantity < 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.error.textContent = !this.available ? 'This start date is currently unavailable.' : !campus?.value ? 'Please choose an available campus.' : `Only ${seats} seats are available at this campus.`;
          this.error.hidden = false;
          campus?.focus();
        }
      }, { ...options, capture: true });
      this.render(this.form?.querySelector('[name="id"]')?.value || this.dataset.variantId);
    }
    disconnectedCallback() { this.controller?.abort(); }
    render(id) {
      const previous = this.content.querySelector('[data-course-campus]')?.selectedOptions[0]?.dataset.campusId;
      const template = [...this.querySelectorAll('template[data-course-variant]')].find(item => item.dataset.courseVariant === String(id));
      this.content.replaceChildren();
      this.error.hidden = true;
      this.available = template?.dataset.available === 'true';
      if (!template) {
        this.error.textContent = 'Choose an available start date.';
        this.error.hidden = false;
        return;
      }
      this.content.append(template.content.cloneNode(true));
      const campus = this.content.querySelector('[data-course-campus]');
      const saved = [...campus.options].find(option => option.dataset.campusId === previous && previous);
      if (saved) saved.selected = true;
      else if (campus.options.length === 2) campus.selectedIndex = 1;
      if (campus.options.length === 1) {
        campus.options[0].textContent = 'No campus seats currently available';
      }
      this.selectCampus();
    }
    selectCampus() {
      const option = this.content.querySelector('[data-course-campus]')?.selectedOptions[0];
      this.content.querySelector('[data-course-campus-id]').value = option?.dataset.campusId || '';
      this.content.querySelector('[data-course-address]').textContent = option?.value
        ? [option.value, option.dataset.address, option.dataset.city, option.dataset.province].filter(Boolean).join(', ')
        : 'Select a campus to see where your course takes place.';
      this.error.hidden = true;
    }
  }
  customElements.define('education-course', EducationCourse);
})();
